import { useRef } from "react";

import { TableLayout } from "@/components/layouts/table-layout";
import { SkeletonTable } from "@/components/shared/tables/skeleton-table";
import { VirtualizedTable } from "@/components/ui/virtualized-table";
import { getCoreRowModel, useReactTable } from "@tanstack/react-table";

import type { QueryResponse } from "../types";

import { columns } from "./columns";

type Props = {
  data: QueryResponse[];
  loading?: boolean;
  columnVisibility?: Record<string, boolean>;
};
export const DataTable = ({
  data,
  loading = false,
  columnVisibility,
}: Props) => {
  const tableContainerRef = useRef<HTMLDivElement>(null);

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    state: {
      columnVisibility,
    },
    defaultColumn: {
      size: undefined,
    },
  });

  return (
    <div className="h-full flex rounded-md border">
      <TableLayout ref={tableContainerRef} className="border-0">
        {loading ? (
          <SkeletonTable
            columns={columns}
            columnVisibility={columnVisibility}
            tableContainerRef={tableContainerRef}
          />
        ) : (
          <VirtualizedTable
            loading={loading}
            table={table}
            tableContainerRef={tableContainerRef}
          />
        )}
      </TableLayout>
    </div>
  );
};
